import { TimeDigits } from '@/shared/constants/types'
import { useEffect, useState } from 'react'
import { useStyles } from './styles'

type TimeDisplayProps = {
  timeLeft: TimeDigits
  isDays?: boolean
  styles?: React.CSSProperties
}

type TimeDigitProps = {
  styles?: React.CSSProperties
  digit: string
}

export const TimeDigit = (props: TimeDigitProps) => {
  const { classes } = useStyles()
  const { digit, styles } = props
  const [currentNumber, setCurrentNumber] = useState(digit)
  const [nextNumber, setNextNumber] = useState(digit)
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    if (digit !== currentNumber) {
      setIsAnimating(true)
      setNextNumber(digit)

      const timer = setTimeout(() => {
        setCurrentNumber(digit)
        setIsAnimating(false)
      }, 500)

      return () => clearTimeout(timer)
    }
  }, [digit, currentNumber])

  return (
    <div className={classes.digitContainer} key={currentNumber} style={styles}>
      <div className={`${classes.digit} ${isAnimating ? classes.animatingCurrentNumber : classes.currentNumber}`}>
        {currentNumber}
      </div>
      <div className={`${classes.digit} ${isAnimating ? classes.animatingNextNumber : classes.nextNumber}`}>
        {nextNumber}
      </div>
    </div>
  )
}

export const TimeDisplay = (props: TimeDisplayProps) => {
  const { classes } = useStyles()
  const { timeLeft, styles } = props

  return (
    <div className={classes.container}>
      <TimeDigit digit={timeLeft.hours[0]} styles={styles} />
      <TimeDigit digit={timeLeft.hours[1]} styles={styles} />

      <div className={classes.separator}>:</div>

      <TimeDigit digit={timeLeft.minutes[0]} styles={styles} />
      <TimeDigit digit={timeLeft.minutes[1]} styles={styles} />

      <div className={classes.separator}>:</div>

      <TimeDigit digit={timeLeft.seconds[0]} styles={styles} />
      <TimeDigit digit={timeLeft.seconds[1]} styles={styles} />
    </div>
  )
}
